import React from "react";
import { useDispatch, useSelector } from "react-redux";
import styled from "styled-components";
import media from "../../../../assets/media";
import { getGroupId } from "../../../base/conference";
import { translate } from "../../../base/i18n";
import { getGroupName } from "../../../group";
import { CreateAttendancesButton, FullScreenButton, SharingButton } from "../../../options";
import { RecordingButton } from "../../../recording";
import ConferenceTimer from "../ConferenceTimer";
import ParticipantsCount from "../ParticipantsCount";
import TestAddPerson from "./TestAddPerson";

import { createTaskQueue } from "../../../../modules/util/helpers";

var isRecordingStarted = false;
var isStoppedRecording = true;
var timeTest;

let task = createTaskQueue();
function ConferenceHeader({ 
    t, roomName, screenType, userAgentType 
}) {
    const dispatch = useDispatch();
    const currentGroupId = useSelector(state => getGroupId(state));
    const groupName = useSelector(state => getGroupName(state, currentGroupId));

    return (
        <ConferenceHeaderStyled className="header">
            <div className="option_list left">
                {APP.layout.header.logo && <h1 className="logo_small" style={APP.mateOption.style.smallLogo}> 
                    <span className="blind">logo</span>
                </h1> }
                <div className="left_cover">
                    { currentGroupId !== "" && <span className="text">{t("group.group_id")}</span> }
                    <span className="room_name text">{ currentGroupId !== "" ? groupName : decodeURIComponent(roomName) }</span>
                    <ParticipantsCount />
                    <ConferenceTimer currentGroupId={currentGroupId} />
                </div>
            </div>
            <div className="option_list middle">
                <SharingButton screenType={screenType} />
            </div>
            <div className="option_list right">
                <div className="right_cover">
                    { APP.layout.header.attendance && <CreateAttendancesButton /> }
                    <RecordingButton />
                    { APP.layout.header.fullScreen && <FullScreenButton isOption={false} userAgentType={userAgentType} /> }
                </div>                
                { location.search.indexOf("test") !== -1 && <TestAddPerson /> }
            </div>
        </ConferenceHeaderStyled>
    )
}

export default translate(ConferenceHeader);

const ConferenceHeaderStyled = styled.div`
    ${media.tabletH`
        padding: 0 8px;
        gap: 4px;
        .logo_small {
            display: none!important;
        }

        .option_list {
            &.left {                
                div, .icon {
                    gap: 4px!important;
                }
            } 

            &.right {
                .right_cover {
                    gap: 4px;
                }
                .attendances {
                    width: 40px;
                }
            }    
        }

        .participant_cnt, .work_time {
            &::before {
                content: '|';
                margin: 0 4px!important;
            }
        }
    `} 

    padding: 0 20px;
    box-sizing: border-box;
    display: flex;
    background-color: #0c0e11;
    height: 52px;
    width: 100%;
    min-width: 350px;
    font-size: 14px;
    color: #eee;
    overflow: hidden;
    gap: 8px;

    .option_list {
        display: inline-flex;
        align-items: center;
        flex-basis: 100%;
        gap: 8px;

        &.left {
            margin-left: 0;
            h1, .left_cover {
                margin: 0;
            }

            .text {
                min-width: 38px;
                display: flex;
                justify-content: center;
                align-items: center;
                text-align: center;
            }

            div {
                display: flex;
                gap: 8px;

                .room_name {
                    max-width: 100px;
                    max-height: 36px;
                    display: -webkit-box;
                    -webkit-line-clamp: 2;
                    -webkit-box-orient: vertical;
                    overflow: hidden;
                    word-break: break-all;
                }

                .icon {
                    display: inline-flex;
                    justify-content: center;
                    align-items: center;
                    gap: 8px;

                    &.participant_cnt, &.work_time {
                        &::before {
                            content: '|';
                            margin: 0 8px;
                        }
                    }
                    &.participant_cnt {
                        span { color: #12a3f8!important; }
                    }

                    &.work_time {
                        span { letter-spacing: 1px; }
                    }
                } 
            }
        }

        &.middle {
            justify-content: center;
        }

        &.right {
            margin-right: 0;

            .right_cover {
                margin: 0 0 0 auto;
                display: flex;
                gap: 8px;
                justify-content: center;
                align-items: center;
            }

            .icon, button {
                display: inline-flex;
                margin: 0;
            }

            .rec {
                margin: 0;
                width: 42px;
                height: 17px;
                background-position: -542px -3px;
            }

            .attendances {
                word-break: keep-all;
            } 
        }
    }

   
`;

// const canvas2d = document.getElementById("background_canvas");
        // const context = canvas2d.getContext('2d');

        // canvas2d.width = elementToRecord.clientWidth;
        // canvas2d.height = elementToRecord.clientHeight;

        // if (elementToRecord) {          
            
        //     var canvasStream = canvas2d.captureStream();
        //     canvasStream.fullScreen = true;
        //     canvasStream.width = canvas2d.width;
        //     canvasStream.height = canvas2d.height;
            
        //     var recorder = new RecordRTC(canvasStream, {
        //         type: 'stream', disableLogs: false, frameRate: 120, timeSlice: 10
        //     });

            
        //     function looper() {
          
        //         if (isStoppedRecording) {
        //             return;
        //         }

        //         task.enqueue((onFinish) => {
        //             html2canvas(elementToRecord, { logging: false, grabMouse: true, backgroundColor: null })
        //                 .then((canvas) => {
        //                     context.drawImage(canvas , 0, 0, canvas2d.width, canvas2d.height);

        //                     onFinish();
        //                 })
        //                 .catch(function (error) {
        //                     console.error('oops, something went wrong!', error);

        //                     onFinish();
        //                 });
        //         });
                
        //         requestAnimationFrame(looper);
                
        //     };
                        
        //     isStoppedRecording = false; 
        //     // recorder.startRecording();  
        //     looper();

        //     const sleep = m => new Promise(r => setTimeout(r, m));
        //     await sleep(3000);         
            
            
        //     // setTimeout(() => {
        //     //     recorder.stopRecording(function() {
                    
        //     //         // task.enqueue((onFinish) => {
                        
        //     //             isStoppedRecording = true;
        //     //             console.log(new Date().getTime(), " finishe ", count)
        //     //             const fileRecord = new Record();
        //     //             var blob = recorder.getBlob({type: 'video/webm'});

        //     //             recorder.reset();
        //     //             if (blob.size > 0) fileRecord.getSaveFile("test", blob);

        //     //         //     onFinish();
        //     //         // });
        //     //     });
        //     // }, 5000);